<!--
Author: jiangli
Date: 2021-03-25
Desc: 账户查询
 -->
<template>
    <div :class="'bizcomp-trade-record bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/fund' }">基金交易</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>

        <div class="trade-record">
            <!-- 表格start -->
            <el-table
                :data="acconts"
                style="width: 100%"
                class="tab-list-tit"
                :row-key="getRowKeys"
            >
                <el-table-column prop="taserialno" label="基金账号" align="center" />
                <el-table-column
                    prop="transactioncfmdate"
                    label="交易账号"
                    align="center"
                    :formatter="formatterDate"
                />
                <el-table-column
                    prop="fundname"
                    label="支付渠道"
                    align="center"
                    :formatter="formatterName"
                ></el-table-column>
                <el-table-column prop="confirmedvol" label="TA" align="center"></el-table-column>
                <el-table-column
                    prop="confirmedamount"
                    label="托管网点"
                    align="center"
                    :formatter="formatterCfmAmount"
                ></el-table-column>
                <el-table-column
                    prop="confirmedamount"
                    label="账户状态"
                    align="center"
                ></el-table-column>
            </el-table>
            <!-- 表格end -->

            <!-- 分页start -->
            <el-row v-if="allPage > pagecount" class="page-box">
                <el-pagination
                    :page-size="Number(pagecount)"
                    :current-page.sync="curPage"
                    background
                    layout="prev, pager, next"
                    :total="Number(allPage)"
                    v-on:current-change="pageRefresh"
                />
            </el-row>
            <!-- 分页end -->
        </div>
    </div>
</template>
<script>
import format from "date-fns/format";
import mixin from "@/assets/js/mixin";

export default {
    name: "AccountSearch",
    mixins: [mixin],
    data() {
        return {
            curPage: 1, // 当前页码
            acconts: [], // 表格数据
            endDate: "", // 结束时间
            beginDate: "", // 开始时间
            nowDate: "", // 当前时间
            pagecount: "", // 页码大小
            pageoffset: "0", // 传给服务器的页数
            allPage: "0", // 数据总数量
            queryFind: null, // 限制前后两次请求间隔时间的定时器
            query: null, // 限制规定时间内请求次数的定时器
            index: 0 // 连续点击次数
        };
    },

    created() {
        this.nowDate = format(new Date(), "YYYYMMDD");
        // 初始化页码
        this.pagecount = this.$util.getConfig().const.PAGE_SIZE;
    },

    methods: {
        // 格式化日期
        formatterDate(row, column, value) {
            return this.$util.fmtDate(value);
        },

        // 格式化基金名称
        formatterName(row, column, value) {
            if (
                row.businesscode === "36" ||
                row.businesscode === "D2" ||
                row.businesscode === "69" ||
                (row.businesscode === "24" &&
                    (row.businesskind === "2" || row.businesskind === "6"))
            ) {
                return row.targetfundname + "(" + row.targetfundcode + ")";
            }
            return row.fundname + "(" + row.fundcode + ")";
        },

        // 格式化金额
        formatterCfmAmount(row, column, value) {
            return this.$util.fmtNum(value);
        },

        // 指定每行row-key
        getRowKeys(row) {
            return row.appsheetserialno;
        },

        // 改变分页
        pageRefresh(val) {
            this.pageoffset = val - 1;
            this.doAction();
        },

        // 连续请求次数限制
        actionLimit() {
            const _this = this;
            if (this.query !== null) {
                clearTimeout(this.query);
                this.index++;
            }
            this.query = setTimeout(() => {
                _this.index = 0;
                clearTimeout(this.query);
            }, 2000);
            if (this.index > 3) {
                this.$alert("您请求太频繁，请等待一会！", "访问提示");
                this.query = setTimeout(() => {
                    _this.index = 0;
                    clearTimeout(this.query);
                }, 500);
            }
            return true;
        },

        // 对频繁查询请求做处理
        doAction(val, cb) {
            // 连续请求次数限制
            // this.actionLimit();
            this.acconts = [];
            this.allPage = 0;
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 100);
        },

        // 获取账号信息
        getFund(val, cb) {}
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
</style>
